import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderByPipe } from '@app/_pipes/order-by.pipe';
import { CustomListPipe } from './custom-list.pipe';
import { TableFilterPipe } from './table-filter.pipe';
import { LocalDatePipe } from './loacl-date.pipe';
import { SecondsToHmsPipe } from './seconds-to-hms.pipe';

@NgModule({
  declarations: [
    OrderByPipe,
    CustomListPipe,
    TableFilterPipe,
    LocalDatePipe,
    SecondsToHmsPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    OrderByPipe,
    CustomListPipe,
    TableFilterPipe,
    LocalDatePipe,
    SecondsToHmsPipe
  ]
})
export class SharedPipeModule { }
